import React, { useState, useEffect } from "react";
import ItemListing from "../../components/ItemListing";
import ApartmentIcon from "@material-ui/icons/Apartment";
import Loader from "../../components/Loader";
import { Button, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getApi, postApi } from "../../services/api";
import { UPLOAD_STATE_VILLAGE_CSV, STATES } from "../../configs/urls";
import { ROLES } from "../../configs/constant";

const loggedInUser = localStorage.user ? JSON.parse(localStorage.user) : {};

const useStyles = makeStyles((theme) => ({
  whiteBg: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
}));

export default function States() {
  const classes = useStyles();
  const [isRequesting, setIsRequestig] = useState(false);
  const [states, setStates] = useState([]);

  useEffect(() => {
    fetchStates();
  }, []); //eslint-disable-line

  const fetchStates = () => {
    setIsRequestig(true);
    getApi(STATES)
      .then(
        (res) => {
          const states = res.data || [];
          setStates(states);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const uploadCSV = (event) => {
    const file = event.target.files[0];
    if (file.type !== "text/csv") {
      alert("Please upload valid csv file.");
      return;
    }
    setIsRequestig(true);
    const data = new FormData();
    data.append("state_and_village_data", file);
    postApi(UPLOAD_STATE_VILLAGE_CSV, data)
      .then(
        (res) => {
          setIsRequestig(true);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  return (
    <div>
      <Loader isLoading={isRequesting} />
      {loggedInUser.role && loggedInUser.role.id == ROLES.SUPER_ADMIN && (
        <Button variant="outlined" color="primary" component="label">
          Upload CSV
          <input
            type="file"
            style={{ display: "none" }}
            accept="text/csv"
            onChange={uploadCSV}
          />
        </Button>
      )}
      {states.length > 0 ? (
        <ItemListing
          pageTitle={"States"}
          data={states}
          canShowEdit={false}
          canShowDelete={false}
          avatarIcon={<ApartmentIcon />}
        />
      ) : (
        <div className={classes.whiteBg}>
          <Box
            fontSize="h6.fontSize"
            m={1}
            p={{ xs: 2, sm: 2, md: 2 }}
            style={{ textAlign: "center" }}
          >
            No States Found
          </Box>
        </div>
      )}
    </div>
  );
}
